import { useMemo, useState } from 'react';

export type TOptionItem = {
  value: string;
  key: string;
  label: string;
};

const useSelectSearch = (
  items: any[],
  valueKey: string = 'id',
  labelKey: string = 'name'
): [TOptionItem[], any] => {
  const [filterQuery, setFilterQuery] = useState('');

  const optionizedItems = useMemo(
    () =>
      (items || []).map((el) => ({
        value: el[valueKey],
        key: el[valueKey],
        label: el[labelKey],
      })),
    [items, labelKey, valueKey]
  );

  const filteredItems: TOptionItem[] = useMemo(() => {
    if (!filterQuery || !filterQuery.length) return optionizedItems;
    const normalizedQuery = filterQuery.toLowerCase();
    const filteredItems = optionizedItems.filter(
      (el) =>
        !!(
          el.label &&
          el.label.toString().toLowerCase().includes(normalizedQuery)
        )
    );
    return filteredItems;
  }, [optionizedItems, filterQuery]);

  return [filteredItems, setFilterQuery];
};

export default useSelectSearch;
